import type { Object3D } from "three/webgpu";

export const INTERACTION_LAYER = 31;

export function configureInteractionObject(object: Object3D, pickEnabled = false) {
  object.layers.set(INTERACTION_LAYER);
  object.userData.pickEnabled = pickEnabled;
}
